import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "space-y-4"
};
const _hoisted_2 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
  class: "rounded-lg border border-slate-200 bg-slate-50 p-3"
};
const _hoisted_5 = {
  class: "grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-3"
};
const _hoisted_6 = {
  class: "block min-w-0"
};
const _hoisted_7 = ["value"];
const _hoisted_8 = {
  class: "block min-w-0"
};
const _hoisted_9 = {
  class: "block min-w-0"
};
const _hoisted_10 = {
  class: "block min-w-0"
};
const _hoisted_11 = {
  class: "block min-w-0"
};
const _hoisted_12 = ["value"];
const _hoisted_13 = {
  class: "flex items-end min-w-0"
};
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
  class: "overflow-hidden rounded-lg border border-slate-200"
};
const _hoisted_16 = {
  class: "min-w-[1280px] w-full divide-y divide-slate-200 text-sm"
};
const _hoisted_17 = {
  class: "divide-y divide-slate-100 bg-white"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "data-table-sticky-left data-table-sticky-identity px-4 py-3"
};
const _hoisted_21 = {
  class: "font-medium text-slate-900"
};
const _hoisted_22 = {
  key: 0,
  class: "mt-1 text-xs text-amber-600"
};
const _hoisted_23 = {
  key: 1,
  class: "mt-1 flex max-w-[260px] flex-wrap gap-1"
};
const _hoisted_24 = {
  class: "whitespace-nowrap px-4 py-3 text-slate-600"
};
const _hoisted_25 = {
  class: "whitespace-nowrap px-4 py-3 text-slate-600"
};
const _hoisted_26 = {
  class: "whitespace-nowrap px-4 py-3 text-slate-600"
};
const _hoisted_27 = {
  class: "whitespace-nowrap px-4 py-3 text-slate-600"
};
const _hoisted_28 = {
  class: "whitespace-nowrap px-4 py-3"
};
const _hoisted_29 = {
  class: "whitespace-nowrap px-4 py-3 text-right tabular-nums text-slate-700"
};
const _hoisted_30 = {
  class: "whitespace-nowrap px-4 py-3 text-right tabular-nums text-slate-700"
};
const _hoisted_31 = {
  class: "max-w-[180px] px-4 py-3 text-slate-600"
};
const _hoisted_32 = ["title"];
const _hoisted_33 = {
  class: "max-w-[180px] px-4 py-3 text-slate-600"
};
const _hoisted_34 = ["title"];
const _hoisted_35 = {
  class: "whitespace-nowrap px-4 py-3 text-slate-600"
};
const _hoisted_36 = {
  key: 0,
  class: "mt-1 space-y-0.5 text-xs text-slate-500"
};
const _hoisted_37 = ["title"];
const _hoisted_38 = ["title"];
const _hoisted_39 = {
  class: "data-table-sticky-right data-table-sticky-action px-4 py-3"
};
const _hoisted_40 = {
  class: "flex justify-end gap-2 whitespace-nowrap"
};
const _hoisted_41 = ["disabled", "onClick"];
const _hoisted_42 = ["disabled", "onClick"];
const _hoisted_43 = ["disabled", "onClick"];
const _hoisted_44 = ["disabled", "onClick"];
const _hoisted_45 = ["disabled", "onClick"];
import { DocumentTextIcon, MinusCircleIcon, PencilSquareIcon, PlusCircleIcon, TrashIcon } from '@heroicons/vue/24/outline';
import AppPagination from '@/components/AppPagination.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import { formatProductQuotaSummary } from '../productQuota';
import { useWheelToHorizontalScroll } from '../composables/useWheelToHorizontalScroll';
import { downstreamAllocationSummary, downstreamPreferenceSummary } from '../downstreamRules.mjs';
export default {
  __name: 'InvoiceMonthlyCustomerWorkbench',
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    syncing: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: String,
      default: ''
    },
    joinedFilter: {
      type: String,
      default: 'all'
    },
    plannerUserId: {
      type: [Number, String],
      default: null
    },
    financeUserId: {
      type: [Number, String],
      default: null
    },
    channelSource: {
      type: String,
      default: ''
    },
    customerTags: {
      type: Array,
      default: () => []
    },
    downstreamAllocations: {
      type: Array,
      default: () => []
    },
    downstreamTagPreferences: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 20
    },
    total: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:keyword', 'update:joined-filter', 'update:planner-user-id', 'update:finance-user-id', 'update:channel-source', 'search', 'page-change', 'size-change', 'create-master', 'edit-master', 'delete-master', 'join-month', 'edit-month', 'remove-month'],
  setup(__props) {
    const props = __props;
    const customerTableScrollRef = useWheelToHorizontalScroll();
    function statusClass(row) {
      return ['inline-flex rounded-full px-2 py-0.5 text-xs font-medium', row.joinedCurrentMonth ? 'status-badge is-success' : 'status-badge is-neutral'];
    }
    function formatAmount(value) {
      if (value === null || value === undefined || value === '') return '-';
      const amount = Number(value);
      if (!Number.isFinite(amount)) return '-';
      return amount.toLocaleString('zh-CN', {
        maximumFractionDigits: 0
      });
    }
    function formatRate(value) {
      if (value === null || value === undefined || value === '') return '-';
      const rate = Number(value);
      if (!Number.isFinite(rate)) return '-';
      return `${(rate * 100).toFixed(2)}%`;
    }
    function planCustomerOf(row) {
      return {
        ...row,
        id: row.planCustomerId,
        companyNameSnapshot: row.companyNameSnapshot || row.companyName,
        regionBucketId: row.regionBucketId,
        targetOutputAmount: row.targetOutputAmount,
        targetProfitRate: row.targetProfitRate
      };
    }
    function customerTagsOf(row) {
      if (Array.isArray(row.customerTags)) return row.customerTags;
      if (Array.isArray(row.tags)) return row.tags;
      if (Array.isArray(row.tagIds)) {
        const selected = new Set(row.tagIds.map(id => String(id)));
        return props.customerTags.filter(tag => selected.has(String(tag.id)));
      }
      return [];
    }
    function downstreamSummaryText(row) {
      if (!row.joinedCurrentMonth) return '';
      const summary = downstreamAllocationSummary(props.downstreamAllocations, planCustomerOf(row));
      if (summary.enabledCount === 0) return '未指定下游';
      return `已指定 ${summary.enabledCount} 个下游，合计 ${formatAmount(summary.totalAmount)}`;
    }
    function preferenceSummaryText(row) {
      if (!row.joinedCurrentMonth) return '';
      const summary = downstreamPreferenceSummary(props.downstreamTagPreferences, row.planCustomerId);
      return summary.enabledCount === 0 ? '未设置标签偏好' : summary.shortText;
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "min-w-0 flex-1"
      }, [_createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "月度客户"), _createElementVNode("p", {
        class: "mt-1 text-sm text-slate-500"
      }, "维护客户主档，并为当前月份配置开票额度、利润率和名单区域。")], -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-primary shrink-0 whitespace-nowrap",
        disabled: __props.syncing,
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('create-master'))
      }, [...(_cache[11] || (_cache[11] = [_createTextVNode(" 新增客户 ", -1)]))], 8, _hoisted_3)), [[_directive_permission, 'enterprise-invoice:customer:create']])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("label", _hoisted_6, [_cache[13] || (_cache[13] = _createElementVNode("span", {
        class: "filter-label"
      }, "关键字", -1)), _createElementVNode("input", {
        value: __props.keyword,
        type: "search",
        class: "form-input form-control-sm mt-1 w-full",
        placeholder: "搜索公司或注册地",
        onInput: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:keyword', $event.target.value)),
        onKeydown: _cache[2] || (_cache[2] = _withKeys($event => _ctx.$emit('search'), ["enter"]))
      }, null, 40, _hoisted_7)]), _createElementVNode("label", _hoisted_8, [_cache[14] || (_cache[14] = _createElementVNode("span", {
        class: "filter-label"
      }, "本月状态", -1)), _createVNode(_component_el_select, {
        "model-value": __props.joinedFilter,
        class: "form-select form-control-sm mt-1 w-full",
        onChange: _cache[3] || (_cache[3] = $event => _ctx.$emit('update:joined-filter', $event))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: "all"
        }), _createVNode(_component_el_option, {
          label: "已加入本月",
          value: "joined"
        }), _createVNode(_component_el_option, {
          label: "未加入本月",
          value: "notJoined"
        })]),
        _: 1
      }, 8, ["model-value"])]), _createElementVNode("label", _hoisted_9, [_cache[15] || (_cache[15] = _createElementVNode("span", {
        class: "filter-label"
      }, "规划师", -1)), _createVNode(UserSelector, {
        "model-value": __props.plannerUserId,
        class: "selector-compact mt-1",
        multiple: false,
        placeholder: "选择规划师",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.$emit('update:planner-user-id', $event))
      }, null, 8, ["model-value"])]), _createElementVNode("label", _hoisted_10, [_cache[16] || (_cache[16] = _createElementVNode("span", {
        class: "filter-label"
      }, "财务专员", -1)), _createVNode(UserSelector, {
        "model-value": __props.financeUserId,
        class: "selector-compact mt-1",
        multiple: false,
        placeholder: "选择财务专员",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.$emit('update:finance-user-id', $event))
      }, null, 8, ["model-value"])]), _createElementVNode("label", _hoisted_11, [_cache[17] || (_cache[17] = _createElementVNode("span", {
        class: "filter-label"
      }, "渠道来源", -1)), _createElementVNode("input", {
        value: __props.channelSource,
        type: "search",
        class: "form-input form-control-sm mt-1 w-full",
        placeholder: "输入渠道",
        onInput: _cache[6] || (_cache[6] = $event => _ctx.$emit('update:channel-source', $event.target.value)),
        onKeydown: _cache[7] || (_cache[7] = _withKeys($event => _ctx.$emit('search'), ["enter"]))
      }, null, 40, _hoisted_12)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("button", {
        type: "button",
        class: "btn-secondary h-9 w-full whitespace-nowrap",
        disabled: __props.syncing || __props.loading,
        onClick: _cache[8] || (_cache[8] = $event => _ctx.$emit('search'))
      }, " 查询 ", 8, _hoisted_14)])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
        ref_key: "customerTableScrollRef",
        ref: customerTableScrollRef,
        class: "overflow-x-auto"
      }, [_createElementVNode("table", _hoisted_16, [_cache[20] || (_cache[20] = _createElementVNode("thead", {
        class: "bg-slate-50 text-left text-xs font-semibold text-slate-500"
      }, [_createElementVNode("tr", null, [_createElementVNode("th", {
        class: "data-table-sticky-left data-table-sticky-head data-table-sticky-identity whitespace-nowrap px-4 py-3"
      }, "公司名称"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3"
      }, "注册地"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3"
      }, "财务专员"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3"
      }, "规划师"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3"
      }, "渠道来源"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3"
      }, "本月状态"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3 text-right"
      }, "本月开票额度"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3 text-right"
      }, "本月利润率"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3"
      }, "进项品名"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3"
      }, "销项品名"), _createElementVNode("th", {
        class: "whitespace-nowrap px-4 py-3"
      }, "名单区域"), _createElementVNode("th", {
        class: "data-table-sticky-right data-table-sticky-head data-table-sticky-action whitespace-nowrap px-4 py-3 text-right"
      }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_17, [__props.loading ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[18] || (_cache[18] = [_createElementVNode("td", {
        colspan: "12",
        class: "px-4 py-10 text-center text-slate-500"
      }, "加载中...", -1)]))])) : __props.rows.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [...(_cache[19] || (_cache[19] = [_createElementVNode("td", {
        colspan: "12",
        class: "px-4 py-10 text-center text-slate-500"
      }, "暂无客户", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 2
      }, _renderList(__props.rows, row => {
        return _openBlock(), _createElementBlock("tr", {
          key: row.customerId,
          class: "hover:bg-slate-50"
        }, [_createElementVNode("td", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(row.companyName || '-'), 1), row.companyNameSnapshot && row.companyNameSnapshot !== row.companyName ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 本月快照：" + _toDisplayString(row.companyNameSnapshot), 1)) : _createCommentVNode("", true), customerTagsOf(row).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerTagsOf(row), tag => {
          return _openBlock(), _createElementBlock("span", {
            key: tag.id,
            class: "data-table-inline-tag"
          }, _toDisplayString(tag.tagName), 1);
        }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_24, _toDisplayString(row.registeredRegion || '-'), 1), _createElementVNode("td", _hoisted_25, _toDisplayString(row.financeUserName || '-'), 1), _createElementVNode("td", _hoisted_26, _toDisplayString(row.plannerUserName || '-'), 1), _createElementVNode("td", _hoisted_27, _toDisplayString(row.channelSource || '-'), 1), _createElementVNode("td", _hoisted_28, [_createElementVNode("span", {
          class: _normalizeClass(statusClass(row))
        }, _toDisplayString(row.joinedCurrentMonth ? '已加入本月' : '未加入本月'), 3)]), _createElementVNode("td", _hoisted_29, _toDisplayString(formatAmount(row.targetOutputAmount)), 1), _createElementVNode("td", _hoisted_30, _toDisplayString(formatRate(row.targetProfitRate)), 1), _createElementVNode("td", _hoisted_31, [_createElementVNode("span", {
          class: "line-clamp-2",
          title: row.joinedCurrentMonth ? _unref(formatProductQuotaSummary)(row.inputProductQuotas).fullText : ''
        }, _toDisplayString(row.joinedCurrentMonth ? _unref(formatProductQuotaSummary)(row.inputProductQuotas).shortText : '-'), 9, _hoisted_32)]), _createElementVNode("td", _hoisted_33, [_createElementVNode("span", {
          class: "line-clamp-2",
          title: row.joinedCurrentMonth ? _unref(formatProductQuotaSummary)(row.outputProductQuotas).fullText : ''
        }, _toDisplayString(row.joinedCurrentMonth ? _unref(formatProductQuotaSummary)(row.outputProductQuotas).shortText : '-'), 9, _hoisted_34)]), _createElementVNode("td", _hoisted_35, [_createTextVNode(_toDisplayString(row.regionName || '-') + " ", 1), row.joinedCurrentMonth ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", {
          title: downstreamSummaryText(row)
        }, _toDisplayString(downstreamSummaryText(row)), 9, _hoisted_37), _createElementVNode("div", {
          title: preferenceSummaryText(row)
        }, _toDisplayString(preferenceSummaryText(row)), 9, _hoisted_38)])) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "table-action-button is-primary",
          title: "编辑主档",
          "aria-label": "编辑主档",
          disabled: __props.syncing,
          onClick: $event => _ctx.$emit('edit-master', row)
        }, [_createVNode(_unref(PencilSquareIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_41)), [[_directive_permission, 'enterprise-invoice:customer:update']]), row.joinedCurrentMonth ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "table-action-button is-primary",
          title: "编辑开票",
          "aria-label": "编辑开票",
          disabled: __props.syncing,
          onClick: $event => _ctx.$emit('edit-month', row)
        }, [_createVNode(_unref(DocumentTextIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_42)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']]) : _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "table-action-button is-primary",
          title: "加入本月",
          "aria-label": "加入本月",
          disabled: __props.syncing,
          onClick: $event => _ctx.$emit('join-month', row)
        }, [_createVNode(_unref(PlusCircleIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_43)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']]), row.joinedCurrentMonth ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "table-action-button is-danger",
          title: "移除本月",
          "aria-label": "移除本月",
          disabled: __props.syncing,
          onClick: $event => _ctx.$emit('remove-month', row)
        }, [_createVNode(_unref(MinusCircleIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_44)), [[_directive_permission, 'enterprise-invoice:plan-customer:manage']]) : _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 3,
          type: "button",
          class: "table-action-button is-danger",
          title: "删除主档",
          "aria-label": "删除主档",
          disabled: __props.syncing,
          onClick: $event => _ctx.$emit('delete-master', row)
        }, [_createVNode(_unref(TrashIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_45)), [[_directive_permission, 'enterprise-invoice:customer:delete']])])])]);
      }), 128))])])], 512)]), _createVNode(AppPagination, {
        current: __props.page,
        size: __props.size,
        total: __props.total,
        "page-sizes": [10, 20, 50, 100],
        onPageChange: _cache[9] || (_cache[9] = $event => _ctx.$emit('page-change', $event)),
        onSizeChange: _cache[10] || (_cache[10] = $event => _ctx.$emit('size-change', $event))
      }, null, 8, ["current", "size", "total"])]);
    };
  }
};